/* eslint-disable react/jsx-one-expression-per-line,react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ds from 'designsystem';
import { isOnMobile } from 'common/responsive';
import root from 'window-or-global';
import { HeroImage as HeroImageModel } from 'models';
import Container from 'blocks/Container/Container';
import { inject, observer } from 'mobx-react';
import { Bind, Debounce } from 'lodash-decorators';
import { observable } from 'mobx';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES } from 'animations/Animations';
import googlePlay from 'common/images/google-play-badge.png';
import appStore from 'common/images/app-store-badge.png';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import Headline from './TextBlock/Headline';
import Description from './TextBlock/Description';
import ButtonsWrapper from './TextBlock/ButtonsWrapper';
import TextWrapper from './TextBlock/TextWrapper';
import ImageBlock from './ImageBlock';
import LinkImage from './TextBlock/LinkImage';
import BlackButton from './TextBlock/BlackButton';

const FlexContainer = styled.div`
  display: flex;
`;

@inject('productsStore')
@observer
class HeroImage extends Component {
  isMobile = observable.box(isOnMobile());

  static propTypes = {
    data: PropTypes.instanceOf(HeroImageModel).isRequired,
  };

  componentDidMount() {
    root.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    root.removeEventListener('resize', this.updateDimensions);
  }

  @Bind
  @Debounce(200)
  updateDimensions() {
    this.isMobile.set(isOnMobile());
  }

  render() {
    const {
      data: {
        header,
        description,
        backgroundHand,
        backgroundDesks,
        htmlModifiers,
        floatingElements,
      },
    } = this.props;

    const {
      productsStore: {
        currentProduct: {
          appStoreShareLink,
          googlePlayShareLink,
        },
      },
    } = this.props;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('background')}
      >
        <Container>
          <FlexContainer>
            <TextWrapper>
              <Fade
                distance={`${FADE_VALUES.TEXT.SMALL}`}
                delay={FADE_VALUES.DELAY.SMALL}
                bottom
              >
                <Headline
                  primary
                  dangerouslySetInnerHTML={{ __html: safeHtmlWithBr(header) }}
                />
                {this.isMobile.get() ? (
                  <ImageBlock
                    backgroundHand={backgroundHand}
                    backgroundDesks={backgroundDesks}
                    floatingElements={floatingElements}
                  />
                ) : ''}
                <Description
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
                <ButtonsWrapper>
                  <BlackButton
                    href={googlePlayShareLink}
                    rightPad
                    rel="nofollow"
                  >
                    <LinkImage
                      src={googlePlay}
                    />
                  </BlackButton>
                  <BlackButton
                    href={appStoreShareLink}
                    rel="nofollow"
                  >
                    <LinkImage
                      src={appStore}
                    />
                  </BlackButton>
                </ButtonsWrapper>
              </Fade>
            </TextWrapper>
            {!this.isMobile.get() ? (
              <ImageBlock
                backgroundHand={backgroundHand}
                backgroundDesks={backgroundDesks}
                floatingElements={floatingElements}
              />
            ) : ''}
          </FlexContainer>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}

export default HeroImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/index.jsx